export enum FormulaCase {
  Uppercase = "uppercase",
  Lowercase = "lowercase",
  Normal = "normal",
}

export interface IImage {
  path: string;
  hash: string;
  formula: string;
  formulaCase: FormulaCase;
  createdAt: string;
  updatedAt: string;
}
